"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-size: 2rem;\n  color: var(--color-primary-light-3);\n\n  margin-left: 3rem;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  & ", " {\n    position: relative;\n    cursor: pointer;\n\n    &::after {\n      content: '\u623B\u308B';\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n\n      font-size: var(--font-size-large);\n      font-weight: bold;\n      color: #fff;\n      background-color: rgba(0, 0, 0, 0.3);\n      border-radius: inherit;\n\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      pointer-events: none;\n\n      opacity: 0;\n      transition: opacity 0.2s;\n    }\n  }\n\n  &:hover ", " {\n    &:after {\n      opacity: 1;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var gallery_card_styles_1 = require("../../common-components/gallery-card/gallery-card.styles");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

exports.StyledParentNoderDiv = styled_components_1.default.div(_templateObject(), gallery_card_styles_1.StyledGalleryCardDiv, gallery_card_styles_1.StyledGalleryCardDiv);
exports.StyledFontAwesomeIcon = styled_components_1.default(react_fontawesome_1.FontAwesomeIcon)(_templateObject2());